import { Accessor, Setter, createSignal } from "solid-js";

export class ParentSelectContext {
    identity: Accessor<string | undefined>;
    setIdentity: Setter<string | undefined>;

    constructor() {
        [this.identity, this.setIdentity] = createSignal<string>();
    }
}
